<template>
    <!--弹窗-->
    <el-dialog width="500px" class="media_dialog" :title="title" :visible.sync="visible" :before-close="handleClose" top="8vh">
        <div style="max-height: calc(84vh - 129px);;overflow: auto;padding: 0 20px;">
            <div style="margin-bottom: 10px;"> 共计 <span style="color: #3498db;">{{this.list.length}}</span> 个子ASIN</div>
            <el-table
                v-loading="loading"
                :data="list"
                size="mini"
                stripe
                border>
                <el-table-column
                    :resizable="false"
                    align="center"
                    label="子ASIN">
                    <template slot-scope="scope">
                        <span>{{scope.row}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    :resizable="false"
                    align="center"
                    label="子ASIN">
                    <template slot-scope="scope">
                        <span>{{scope.row}}</span>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <el-row style="margin-top:17px; ">
            <el-button v-if="isshowbutton" size="mini" type="success" style="margin-left: 20px;" @click="updateList()" :disabled="disabled">更新列表</el-button>
            <el-button
                style="float:right;margin-right: 20px;"
                size="mini"
                plain
                @click="handleClose()"
            >关 闭</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            loading: false,
            disabled: false,
            list: [],
            product_id: ""
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        isshowbutton: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        //获取列表
        getList(id) {
            this.loading = true;
            this.product_id = id;
            api.variations({ product_id: id })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //更新列表
        updateList() {
            this.disabled = true;
            api.update_sub_asin({ product_id: this.product_id })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        this.list = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        // 关闭弹窗
        handleClose() {
            this.list = [];
            this.$emit("close-callback", true);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
/deep/ .el-dialog__body {
    padding: 0px 0 20px 0 !important;
}
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
